import { render } from "./DesktopSidebar.vue?vue&type=template&id=9b28edd6&scoped=true"
import script from "./DesktopSidebar.vue?vue&type=script&lang=js"
export * from "./DesktopSidebar.vue?vue&type=script&lang=js"

import "./DesktopSidebar.vue?vue&type=style&index=0&id=9b28edd6&scoped=true&lang=css"
import "./DesktopSidebar.vue?vue&type=style&index=1&id=9b28edd6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b28edd6"]])

export default __exports__